import { useTheme } from "@mui/system";

export default function MainIcon() {
  const theme = useTheme();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10M10 2.5C14.1421 2.5 17.5 5.85786 17.5 10M10 2.5V10M17.5 10H10M15 15.4167L10 10" 
        stroke={theme.palette.rgd.primary}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  )
}